import { useContext, useEffect } from 'react';
import FooterContext from '../contexts/FooterStateContext';

/**
 * Control the footer. By default, the footer is shown with navigation. You only need to use this
 *  if you desire to change the visibility of the footer, or the navigation visibility within
 *  the footer.
 * @param showFooter (Optional) Whether the footer should be visible
 * @param showFooterNav (Optional) Whether the footer should show the navigation
 */
const useFooterControl = (showFooter = true, showFooterNav = true) => {
  const footerContext = useContext(FooterContext);

  useEffect(() => {
    footerContext.showFooter(showFooter);
    footerContext.showFooterNav(showFooterNav);

    return () => {
      footerContext.showFooter(true);
      footerContext.showFooterNav(true);
    };
  }, [footerContext, showFooter, showFooterNav]);
};

export default useFooterControl;
